import type {
  PackageDetail,
  PackageDetailsRequest,
  PackageVersion,
  PackageVersionsResponse
} from '../../types/package-version'

import { packagesApiClient } from '../api/packagesApiClient'
import { logger } from '../../utils/logger'

export const packageVersionService = {
  /**
   * Fetch all packages with their versions and deployment information
   */
  async getPackages(): Promise<PackageVersionsResponse> {
    try {
      logger.log('Fetching package versions...')
      const response = await packagesApiClient.get<PackageVersion[]>('/devtools/packages')
      logger.log('Raw API Response:', JSON.stringify(response, null, 2))
      return { data: response, traceId: 'mock' } as PackageVersionsResponse
    } catch (error) {
      logger.error('Failed to fetch package versions:', error)
      throw new Error('Failed to fetch package versions. Please try again later.')
    }
  },

  /**
   * Fetch detailed information for a specific package
   */
  async getPackageDetails(request: PackageDetailsRequest): Promise<PackageDetail> {
    try {
      const _params = new URLSearchParams({
        packageName: request.packageName
      })
      logger.log(`Fetching details for package: ${request.packageName}`, request)
      const response = await packagesApiClient.get<PackageDetail>(
        `/devtools/packages/details`,
        request
      )
      logger.log('Package details fetched successfully:', response)
      return response
    } catch (error) {
      logger.error(`Failed to fetch details for package ${request.packageName}:`, error)
      throw new Error('Failed to fetch package details. Please try again later.')
    }
  },

  /**
   * Export package information in the specified format
   */
  async exportPackages(format: 'csv' | 'json' = 'csv'): Promise<Blob> {
    try {
      logger.log(`Exporting packages in ${format} format...`)
      const response = await packagesApiClient.get<Blob>(
        `/devtools/api/jenkins/packages/export?format=${format}`,
        {
          responseType: 'blob'
        }
      )
      logger.log('Packages exported successfully')
      return response
    } catch (error) {
      logger.error('Failed to export packages:', error)
      throw new Error('Failed to export packages. Please try again later.')
    }
  }
}
